/**
 * PATH: packages/job-hub/src/jobs/tabs/quoteIngestError.ts
 * FILE_ID: JOBHUB-JOBS-QUOTE-INGEST-ERROR-LABEL-001
 * PURPOSE: Name the retry that fixes each quote-import failure class.
 * WHY: Separate from the component so Fast Refresh keeps working, matching the
 *      levelsOf split made for the same lint rule earlier in change #697.
 */

/** What the operator should try, per failure class from the backend. */
const RETRY_LABEL: Record<string, string> = {
  s3_download_failed: 'Retry download',
  enqueue_failed: 'Start parse',
  ingest_failed: 'Retry with AI',
  ingest_rejected: 'Retry with AI',
}

/**
 * Falls back rather than rendering an empty button: the backend may add a
 * failure class before this table learns about it, and a nameless retry is
 * worse than a generic one.
 */
export function retryLabel(code: string | undefined): string {
  return RETRY_LABEL[code ?? ''] ?? 'Retry import'
}
